<div class="ticket-type-bond">
    <p class="title-verify">¿Quieres añadir un abono de 3 días al carrito?</p>

    <div class="d-flex justify-content-between btns-select">
        <button class="w-100 btn btn-cancel" type="button" mat-dialog-close>Cancelar</button>
        <button class="w-100 btn btn-primary btn-ok" type="submit" (click)="addTicketBond()">Añadir
            <i class="fa-light fa-cart-plus" style="font-size: 16px;"></i>
        </button>
    </div>
</div>